import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_CONFIG } from '@core/config/app-config.tokens';
import { AppErrorMapperService } from '@core/error-handling/app-error-mapper.service';
import { HTTP_TIMEOUT_MS } from '@core/http/http-context.tokens';
import { catchError, throwError, TimeoutError } from 'rxjs';

export const apiErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const appConfig = inject(APP_CONFIG);
  const appErrorMapper = inject(AppErrorMapperService);
  const timeoutMs = request.context.get(HTTP_TIMEOUT_MS) ?? appConfig.requestTimeoutMs;

  return next(request).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse || error instanceof TimeoutError)) {
        return throwError(() => error);
      }

      const appError = appErrorMapper.fromHttpError(request, error, {
        timeoutMs,
      });

      return throwError(() => appError);
    }),
  );
};
